module.exports = __webpack_public_path__ + "static/media/html.1ae17d2f.png";